import React, { ChangeEvent, FC } from "react";
import { sanitizeAddFundsAmountInput } from "containers/Books/helpers/addFundsAmountValidation";
import { connect } from "react-redux";
import { authPaypalFeePercent } from "reduxFolder/selectors/globalSelectors";
import { createStructuredSelector } from "reselect";
import { BooksAddPayPalFundsFormProps } from "types/books";
import BooksAddFundsAmountFields from "../BooksAddFunds/BooksAddFundsAmountFields";

const BooksAddPayPalFundsForm: FC<BooksAddPayPalFundsFormProps> = React.memo(
  ({
    values,
    errors: { amount: amountError },
    touched,
    setFieldValue,
    authPaypalFeePercent,
  }) => {
    const handleAmountChange = (event: ChangeEvent<HTMLInputElement>) => {
      const inputValue = sanitizeAddFundsAmountInput(event.target.value);
      setFieldValue("amount", inputValue);
    };

    return (
      <BooksAddFundsAmountFields
        amount={values.amount}
        amountError={amountError}
        touchedAmount={touched.amount}
        onAmountChange={handleAmountChange}
        feePercent={authPaypalFeePercent}
      />
    );
  },
);

const withConnect = connect(
  createStructuredSelector({
    authPaypalFeePercent,
  }),
);

export default withConnect(BooksAddPayPalFundsForm);
